module.exports = __webpack_public_path__ + "img/cog.f2a6b3bc.webp";